/**
 * Type of form-context provided by a FormContext. The different form-context influence control look and feel.
 *
 * @see FUIFormContext
 */
export enum FUIContextType {
    /**
     * Context for controls being used in a regular edit content-layout. This is typically the default form-context.
     */
    EDIT,
    /**
     * Context for controls being used in a pill mode which is typically used for extending the available search fields.
     * Pills are typically styled in a more compact fashion.
     */
    PILL,
    /**
     * Context for controls being used in an inline edit mode such as grid edit. These controls are typically more
     * compact. They may not include a label since typically a grid will include a column header.
     */
    INLINE,
    /**
     * Context for controls being used in a grid column header. These controls are typically more compact.
     */
    HEADER,
    /**
     * Context for controls being used in an inline action mode such as grid selector.
     */
    INLINE_ACTION,
    /**
     * Context for controls being used in a pill mode which is typically used for extending the available search fields.
     * Pills are typically styled in a more compact fashion.
     */
    FILTER,
    /**
     * Context for controls being used in a pop up. These usually have slight differences but resemble the
     * edit inputs, they also have features such as extended search, but do not require validation.
     */
    POP
}
